import {FormItemModel, FormOptionsModel} from '../../../services/models/form.model';
import {RequesterResponseModel} from '../../../services/models/requester.model';
import {DateOutputModel} from '../../../services/models/output.model';

export class CoachingFormResponseModel {
    status: RequesterResponseModel;
    form: CoachingFormModel;
}

export class CoachingFormModel {
    id: number;
    date: FormItemModel;
    dateOutput: DateOutputModel;
    description: FormItemModel;
    type: string;
    coachee_name: {
        value: string;
        options: FormOptionsModel;
        error: string;
    };
    comment_self_1: {
        value: string;
        options: FormOptionsModel;
        error: string;
    };
    comment_self_2: {
        value: string;
        options: FormOptionsModel;
        error: string;
    };
    comment_self_3: {
        value: string;
        options: FormOptionsModel;
        error: string;
    };
    groups: {
        value: CoachingGroupFormModel[];
        options: FormOptionsModel;
        error: string;
    };
    delegate: {
        fullname: string;
    };
    error: string;
    options: FormOptionsModel;
}

export class CoachingGroupFormModel {
    group: string;
    title: string;
    color: string;
    background: string;
    img: string;
    questions: {
        value: CoachingQuestionFormModel[];
        options: FormOptionsModel;
        error: string;
    };
}

export class CoachingQuestionFormModel {
    id: number;
    question: string;
    value: FormItemModel;
}
